// stores/counter.js
import { acceptHMRUpdate, defineStore } from 'pinia';
import { UserSchema, type User } from "~/schemas/user.schema";
// import { UserTokenSchema, type UserToken } from "~/schemas/user_token.schema";

export const useAccounts = defineStore('accounts', {
  persist: true,
  state: (): { account?: User, token?: string, perms?: string[] } => {
    return {
      account: undefined,
      token: '',
      perms: [],      
    };
  },
  getters: {
    isLoggedIn(state) {
      return state.token != '';
    },
  },
  actions: {
    async login(u: string, p: string) {
      const { response, success, error, data } = await useBaseApi<{
        // user: User,
        // token: UserToken,        
        id: string;
        username: string;
        name: string;
        status: string;
        superadmin: string;
        roleid: string | null;
        lastlogin: string;
        lastloginip: string;
        dateadded: string;
        token: string;
        perms: string[];
      }>('api/account/login', {
        method: 'POST',
        body: {
          u,
          p
        }
      });
      if (success) {
        let { user } = data!;       
        this.account = UserSchema.parse(data);
        console.log("this.account", this.account)
        this.token = data?.token;
        // token = UserTokenSchema.parse(token);
        // this.token = token.token;
        
      }
      return { response, success, error };
    },


    async loginToken() {      
      const at = this.token;
      const { response, success, error, data } = await useBaseApi<{
        // user: User,
        // token: UserToken,        
        id: string;
        username: string;
        name: string;
        status: string;
        superadmin: string;
        roleid: string | null;
        lastlogin: string;
        lastloginip: string;
        dateadded: string;
        token: string;
        perms: string[];
      }>('api/account/loginToken', {
        method: 'POST',
        body: {
          at,
        }
      });
      if (success) {
        let { user } = data!;                
        this.account = UserSchema.parse(data);

        // token = UserTokenSchema.parse(token);
        this.token = data?.token;
        // test
      }
      if(error) {
        console.log("error", error);
        this.logout()
      }
      return { response, success, error };
    },

    async logout() {
      const { response, success, error } = await useBaseApi('api/account/logout', {
        method: 'POST',
        body: {
          at: this.token,
        }
      });
      if (success) {
        this.clear();
      }
      return { response, success, error };
    },  

    async clear() {
      this.account = undefined;
      this.token = '';
      this.perms = [];
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAccounts, import.meta.hot))
}
